var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLeave = function SvgLeave(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 3.33398V12.6673C13.3327 13.772 12.4373 14.6673 11.3327 14.6673H4.66602C3.56135 14.6673 2.66602 13.772 2.66602 12.6673V3.33398C2.66602 2.22932 3.56135 1.33398 4.66602 1.33398H11.3327C12.4373 1.33398 13.3327 2.22932 13.3327 3.33398Z",
    fill: "#F3CED2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.66602H7.33333C6.59667 6.66602 6 7.26268 6 7.99935C6 8.73602 6.59667 9.33268 7.33333 9.33268H12V6.66602Z",
    fill: "#EA5353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0527 10.7531C11.0527 11.2671 11.6727 11.5257 12.0381 11.1637L14.6334 8.59308C14.9634 8.26574 14.9634 7.73241 14.6334 7.40508L12.0381 4.83441C11.6727 4.47308 11.0527 4.73174 11.0527 5.24508V10.7531Z",
    fill: "#EA5353"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLeave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "leave.ce7f7a3dc93da1fe478f90458a7bb54b.svg";